import React from 'react';

export const ZoomOut = () => (
    <>
        <circle cx='10' cy='10' r='7' />
        <line x1='7' y1='10' x2='13' y2='10' />
        <line x1='21' y1='21' x2='15' y2='15' />
    </>
);